import { memo, useState, useEffect, useRef } from 'react';
import { isIOS } from 'react-device-detect';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import VeVideo from '@wconcept/wconcept-ui-renewal/components/atoms/VeVideo';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import { IPlayAuthTokenConfig } from '@byteplus/veplayer';
import useInView from '@wconcept/wconcept-ui-renewal/hooks/useInView';
import * as S from './style';

interface IProps {
  videoSrc?: string;
  videoPoster?: string;
  vid?: string;
  token?: IPlayAuthTokenConfig;
  imgSrc?: string;
  rs?: string;
  alt?: string;
  getNewToken?: () => Promise<IPlayAuthTokenConfig>;
  onClick?: () => void;
}

const ImgTitBanner = ({
  videoSrc,
  videoPoster,
  vid,
  token,
  imgSrc,
  rs,
  alt,
  getNewToken,
  onClick,
}: IProps) => {
  const [videoEl, setVideoEl] = useState<any>(null);
  const [ref, isVisible] = useInView({
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });

  const isActive = isVisible;

  const videoElRef = useRef(videoEl);
  const isActiveRef = useRef(isActive);

  useEffect(() => {
    videoElRef.current = videoEl;
    isActiveRef.current = isActive;
  }, [videoEl, isActive]);

  // iOS 백그라운드/포그라운드 전환 감지
  useEffect(() => {
    if (!isIOS) return;

    const handleVisibilityChange = () => {
      const isHidden = document.hidden;

      if (!isHidden && videoElRef.current?.player && isActiveRef.current) {
        setTimeout(() => {
          videoElRef.current?.player?.pause();
        }, 300);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // 화면 내 가시성에 따른 비디오 제어 (useInView 활용)
  useEffect(() => {
    const videoElement = videoEl?.player;
    if (!videoElement) return;

    if (isActive) {
      videoElement.play().catch(() => {});
    } else {
      videoElement.pause();
    }
  }, [isActive, videoEl]);

  return (
    <S.ImgTitBanner ref={ref}>
      {vid || videoSrc ? (
        <VeVideo
          src={videoSrc}
          vid={vid}
          poster={videoPoster}
          token={token}
          getNewToken={getNewToken}
          muted
          loop
          clickControl
          autoplay={false}
          handleComplete={el => {
            if (el?.player) {
              setVideoEl(el);
            }
          }}
        />
      ) : (
        <>
          {(() => {
            const imgElement = (
              <Img
                src={getResizeImageUrl(imgSrc, rs)}
                alt={alt}
                className="img-tit-banner"
                onClick={undefined}
              />
            );

            return onClick ? (
              <Button onClick={onClick}>{imgElement}</Button>
            ) : (
              imgElement
            );
          })()}
        </>
      )}
    </S.ImgTitBanner>
  );
};

export default memo(ImgTitBanner);
